/* 产引入jsencrypt实现数据RSA加密 */
import JSEncrypt from 'jsencrypt' // 处理长文本数据时报错 jsencrypt.js Message too long for RSA
/* 产引入encryptlong实现数据RSA加密 */
import Encrypt from 'encryptlong' // encryptlong是基于jsencrypt扩展的长文本分段加解密功能。
 
// 密钥对生成 http://web.chacuo.net/netrsakeypair
 
// 公钥key
// 公钥key
const publicKey = `-----BEGIN RSA PRIVATE KEY----- 
	  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDt30AcO8CSAfzSa5L8ikVrfehH6aFw9KyL85NzOAduOfnPcbiAGLjLWEKOkOhkYrlSAfU5s+pa3OQTsgpfCkVVm56dEQh8sajIR4uyGbhv0/CdvPTZS5o3sP6Yi9TemWZ443+QNjajN6MSCTmTY86ZoR9jmTcJtV4kNTQWDov6qQIDAQAB
	  -----END RSA PRIVATE KEY-----`
// 私钥key
const privateKey = `-----BEGIN RSA PRIVATE KEY----- 
   MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAO3fQBw7wJIB/NJrkvyKRWt96EfpoXD0rIvzk3M4B245+c9xuIAYuMtYQo6Q6GRiuVIB9Tmz6lrc5BOyCl8KRVWbnp0RCHyxqMhHi7IZuG/T8J289NlLmjew/piL1N6ZZnjjf5A2NqM3oxIJOZNjzpmhH2OZNwm1XiQ1NBYOi/qpAgMBAAECgYAt/RgZfUnlUKIPEoI39gmm1xBV+urd+kfzxNNQltgE7QuJmjxn85+inL09b/GmGtomaz98ePbJu2QTFLxhlIxDueUNuZWp+daDfftV/gaCKJU0sZ/t22OtwegpT3NwcAFx8c74A0k3Sera34R+adUL/ALnQXff6gbMPjw0LU/LCQJBAPpzGlimfeuM2x/F/QwAceGkqMtKyR7kUqN6iux4Bdq8e2wrZwlLYmDsQwDnQ8vujlrFunFXB9hFPmF/nbf1RyUCQQDzJMpNOx7mGl0txsdSOMVsO6qdim78zh3qmBoJLaGWfWuQoF2KR2dyWITaxfuJTGoDGiSOioZYkn4Yy4Zrn0A1AkAS+kHW0dbc0HGSOMhx7l6ywG1h6irPQnHYnWKFhJq89mdLzQYjuCieO4jgOqXygAMdcbos+HFJvAV8EdV7qQRZAkEAl4ChHaZtBmv/C3sEz9LYESzMjwWnSpcURQ0pi/aG7UKRN7j1ECiV6MYHYlpi9ZZLqEst5DOkqqP9Nm37ACxm0QJACfN90x3r+wFR+MJ9BS5yXUNcfRRpcPBOD7D4QrzOMkWUh3QkuaQZSESpud7UUt0PAfFfTFLx4XQyeY9CqdrYTg==
   -----END RSA PRIVATE KEY-----`
 
export default {
  /* JSEncrypt加密 */
  rsaPublicData(data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPublicKey(publicKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data)
    return result
  },
  /* JSEncrypt解密 */
  rsaPrivateData(data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPrivateKey(privateKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data)
    return result
  },
  /* 加密 */
  encrypt(data) {
    const PUBLIC_KEY = publicKey
    var encryptor = new Encrypt()
    encryptor.setPublicKey(PUBLIC_KEY)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    const result = encryptor.encryptLong(data)
    return result
  },
  /* 解密 - PRIVATE_KEY - 验证 */
  decrypt(data) {
    const PRIVATE_KEY = privateKey
    var encryptor = new Encrypt()
    encryptor.setPrivateKey(PRIVATE_KEY)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = encryptor.decryptLong(data)
    return result
  }
}


// WEBPACK FOOTER //
// ./src/common/js/rsa.js